<div class="edit-location">
  <div class="top-part">
    <div class="building-details">
      <div class="address-section building-detail">
        <div class="identifier">{{ 'module.energyMap.descriptionComponent.address' | translate }}</div>
        <div class="value">
          <div>{{ building.fullAddress || '' }}</div>
        </div>
      </div>
      <div class="building-meters building-detail">
        <div class="identifier">Zählernummer</div>
        <div *ngFor="let meter of building.meters" class="value">
          <div>{{ meter.meterNumber || '' }}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="description-gps">
    <label class="description-gps-label">
      {{ 'module.energyMap.descriptionComponent.gpsLocation' | translate }}
    </label>
    <div class="instructions">
      <div class="instruction-item">
        <div class="badge">
          <div class="badge-number">1</div>
        </div>
        <div class="gps-instruction">
          {{ 'module.energyMap.descriptionComponent.gpsInstruction1' | translate }}
        </div>
      </div>

      <div class="instruction-item">
        <div class="badge">
          <div class="badge-number">2</div>
        </div>
        <div class="gps-instruction">
          {{ 'module.energyMap.descriptionComponent.gpsInstruction2' | translate }}
        </div>
      </div>
      <div class="instruction-item">
        <div class="badge">
          <div class="badge-number">3</div>
        </div>
        <div class="gps-instruction">
          {{ 'module.energyMap.descriptionComponent.gpsInstruction3' | translate }}
        </div>
      </div>
      <div class="instruction-item">
        <div class="badge">
          <div class="badge-number">4</div>
        </div>
        <div class="gps-instruction">
          {{ 'module.energyMap.descriptionComponent.gpsInstruction4' | translate }}
        </div>
      </div>
      <div class="instruction-item">
        <div class="badge">
          <div class="badge-number">5</div>
        </div>
        <div class="gps-instruction">
          {{ 'module.energyMap.descriptionComponent.gpsInstruction5' | translate }}
        </div>
      </div>
    </div>
    <div class="object-location-container" *ngIf="!!authService.permissions.BUILDING_LOCATION_UPDATE">
      <button class="btn btn-primary" (click)="localizeObject(building.marker)">
        <span class="fa fa-map-marker" aria-hidden="true"></span>
        <span class="btn-text">{{ 'module.energyMap.descriptionComponent.locateObject' | translate }}</span>
      </button>
    </div>
    <div class="action-btns-container">
      <div class="action-btns">
        <button class="btn save-btn" (click)="save(building)">
          <span class="fa fa-save" aria-hidden="true"></span>
          <span class="btn-text">Speichern</span>
        </button>
        <button (click)="closeDialog()" class="btn btn-outline-secondary cancel-btn">
          <span class="btn-text">Abbrechen</span>
        </button>
      </div>
    </div>
  </div>
</div>
